import { isEmpty } from '../VNUtil/VNUtils'

export const getCurrentOrderUuid = (state) => {
  return state?.VNOrders.get('currentOrderUuid')
}

export const getOrderByUuid = (state, orderUuid) => {
  return state?.VNOrdersPersisted.getIn(['orders', orderUuid])
}

export const getCurrentOrder = (state) => {
  const currentOrderUuid = getCurrentOrderUuid(state)
  return getOrderByUuid(state, currentOrderUuid)
}

export const getAllUnsynedOrders = (state) => {
  return state?.VNOrdersPersisted.get('unsyncedOrders')
}

export const getAllOrders = (state) => {
  return state?.VNOrdersPersisted.get('orders')
}

export const isOrderUnsynced = (state, orderUuid) => {
  const order = state?.VNOrdersPersisted.getIn(['unsyncedOrders', orderUuid])
  return isEmpty(order)
}

export const getOrderAction = (state) => {
  return state?.VNOrders.get('orderAction')
}

export const getTempCurrentOrderPayments = (state) => {
  const currentOrderUuid = getCurrentOrderUuid(state)
  return state?.VNOrdersPersisted.getIn(['tempOrderPayments', currentOrderUuid])
}
